import * as React from "react";

function SubtitlesIcon(props) {
	return (
		<svg
			viewBox="0 0 48 48"
			fill="currentColor"
			height="1em"
			width="1em"
			{...props}
		>
			<path d="M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z" />
		</svg>
	);
}

export default React.memo(SubtitlesIcon);
